import React from "react";
import {CaptionStepComponent, FullCaptionComponent} from "../../../../../app/components/caption/CaptionComponent";
import {CodeComponent} from "../../../../../app/components/code/CodeComponent";

export function HashMapRemoveCabFullCaption() {
    return (<FullCaptionComponent title="VALUE: cab">
        <HashMapRemoveCab1/>
        <HashMapRemoveCab2/>
        <HashMapRemoveCab3/>
        <HashMapRemoveCab4/>
    </FullCaptionComponent>)
}

export function HashMapRemoveCab1() {
    return (<CaptionStepComponent title={<h6>1. Generate <CodeComponent
        className="codeHash">HASH</CodeComponent>. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Let's assume that if we input our <CodeComponent className="codeKey">KEY</CodeComponent> of "abc" into
            our <CodeComponent>generateHash</CodeComponent> function, it will output a <CodeComponent
                className="codeHash">HASH</CodeComponent> of 1.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveCab2() {
    return (<CaptionStepComponent title={<h6>2. Find sub-collection at the <CodeComponent
        className="codeHash">HASH</CodeComponent> index. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>Because our <CodeComponent className="codeHash">HASH</CodeComponent> is 1, we now want to find the
            sub-collection at index 1 of our array.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveCab3() {
    return (<CaptionStepComponent title={<h6>3. Iterate over our sub-collection until we found the <CodeComponent
        className="codeValue">VALUE</CodeComponent> we want to
        remove. <CodeComponent><s>O(n)</s></CodeComponent><CodeComponent>O(1)</CodeComponent></h6>}>
        <p>At <CodeComponent className="codeHash">HASH</CodeComponent> index 1, we only have a single <CodeComponent
            className="codeKey">KEY</CodeComponent> - <CodeComponent className="codeValue">VALUE</CodeComponent> object
            which contains the <CodeComponent className="codeValue">VALUE</CodeComponent> we are looking for, again our
            average case.</p>
    </CaptionStepComponent>)
}

export function HashMapRemoveCab4() {
    return (<CaptionStepComponent
        title={<h6>4. Remove the corresponding <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object from our
            sub-collection. <CodeComponent>O(1)</CodeComponent></h6>}>
        <p>We remove our <CodeComponent className="codeKey">KEY</CodeComponent> - <CodeComponent
            className="codeValue">VALUE</CodeComponent> object of <CodeComponent>abc - cab</CodeComponent> from the
            sub-collection.</p>
    </CaptionStepComponent>)
}
